/** 測定タイプ */
export enum MeasurementType {
	/** なし */
	None = '-',
	/** 施術後 */
	AfterTreatment = 'A',
	/** 施術前 */
	BeforeTreatment = 'B',
}